
import { headerApi, HeaderDto, HeaderRequest } from '@/api/header'
import { isRequiredGenerator, maxLengthGenerator } from '@/utils/rules'
import { formatAddress } from '@/utils/addresses'
import { AxiosResponse } from 'axios'
import { cloneDeep, isEqual } from 'lodash'
import Vue, { PropType } from 'vue'
import ConfirmCancelDialog from '@/components/ConfirmCancelDialog.vue'
import { handleAxiosException } from '@/api'

export default Vue.extend({
  components: { ConfirmCancelDialog },
  props: {
    value: {
      required: true,
      type: Boolean,
    },
    header: Object as PropType<HeaderDto>,
  },
  data() {
    return {
      editing: false,
      error: '',
      valid: true,
      lines: [] as { value: string }[],
      copyLines: [] as { value: string }[],
      // form: {} as HeaderRequest, // champs address existant pour eviter npe
      // copyForm: {} as HeaderRequest,
      confirmCancelDialog: false,
      customerTypes: [
        { key: 'MAN', icon: 'mdi-account' },
        { key: 'COMPANY', icon: 'mdi-domain' },
      ],
      expanded: false,
    }
  },
  methods: {
    // FORMATTERS
    formatAddress,
    // RULES
    isRequiredGenerator,
    maxLengthGenerator,
    // ACTIONS
    cancelEdit() {
      if (!isEqual(this.lines, this.copyLines)) {
        this.confirmCancelDialog = true
      } else {
        this.close()
      }
    },
    confirmConfirmCancelEdit() {
      this.confirmCancelDialog = false
      this.close()
    },
    async saveEdit() {
      if ((this.$refs.form as HTMLFormElement).validate()) {
        this.editing = true
        this.error = ''
        try {
          const form : HeaderRequest = {
            line1: this.lines[0].value,
            line2: this.lines[1].value,
            line3: this.lines[2].value,
          }
          if (this.header) {
            await headerApi.update(this.header.id, form)
            this.$emit('success', this.header)
          } else {
            const header = await headerApi.create(form)
            this.$emit('success', header)
          }
        } catch (err) {
          this.error = this.$t(handleAxiosException(err, (r: AxiosResponse) => r.data?.message ?? 'form.error.global_error')) as string
          this.editing = false
        }
      }
    },
    close() {
      this.$emit('input', false)
    },
  },
  watch: {
    value(val) {
      if (val) {
        this.editing = false
        this.lines = (this.header ? [
          this.header.line1,
          this.header.line2,
          this.header.line3,
        ] : ['', '', '']).map(el => ({ value: el }))
        this.copyLines = cloneDeep(this.lines)
        // on rajoute champs à vide pour que le check de cancel ne s'active pas si on compare vide et undefined
        // this.form = cloneDeep(this.lines)
        // this.copyForm = cloneDeep(this.lines)
        this.valid = true
        // eslint-disable-next-line no-unused-expressions
        ;(this.$refs.form as HTMLFormElement)?.resetValidation()
      }
    },
    valid(val, oldVal) {
      if (!val && oldVal !== val) {
        (this.$refs.form as HTMLFormElement).validate()
      }
    },
  },
})
